export default {
  actions: {
    REQUEST_USER: 'REQUEST_USER',
    RECEIVE_USER: 'RECEIVE_USER',
    REQUEST_LOGOUT: 'REQUEST_LOGOUT',
    RECEIVE_LOGOUT: 'RECEIVE_LOGOUT',
  },
};
